import { render } from "./InformationalLayout.vue?vue&type=template&id=7a905140&scoped=true&ts=true"
import script from "./InformationalLayout.vue?vue&type=script&lang=ts"
export * from "./InformationalLayout.vue?vue&type=script&lang=ts"

import "./InformationalLayout.vue?vue&type=style&index=0&id=7a905140&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a905140"]])

export default __exports__